import React from 'react'

function StudentsComp() {
  return (
    <div>StudentsComp</div>
  )
}

export default StudentsComp